var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisaBrand = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 100 100",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsXodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 49.95,
    y1: 33.74,
    x2: 50.89,
    y2: 66.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#222357"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#254AA5"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "visa-brand.svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M51.72 44.18c-0.06,4.5 4.01,7.01 7.07,8.5 3.15,1.53 4.2,2.51 4.19,3.88 -0.02,2.1 -2.51,3.02 -4.84,3.06 -4.06,0.06 -6.42,-1.1 -8.29,-1.97l-1.47 6.84c1.89,0.87 5.37,1.62 8.99,1.66 8.49,0 14.04,-4.19 14.07,-10.69 0.03,-8.24 -11.4,-8.7 -11.33,-12.38 0.03,-1.12 1.1,-2.31 3.43,-2.61 1.16,-0.16 4.35,-0.27 7.97,1.39l1.42 -6.62c-1.95,-0.71 -4.45,-1.39 -7.56,-1.39 -7.99,0 -13.61,4.25 -13.65,10.33m34.86 -9.76c-1.55,0 -2.86,0.91 -3.44,2.29l-12.12 28.95 8.48 0 1.68 -4.66 10.37 0 0.98 4.66 7.47 0 -6.52 -31.24 -6.9 0m1.18 8.44l2.45 11.73 -6.7 0 4.25 -11.73m-46.32 -8.44l-6.69 31.24 8.08 0 6.68 -31.24 -8.07 0m-11.96 0l-8.41 21.26 -3.4 -18.07c-0.4,-2.02 -1.98,-3.19 -3.73,-3.19l-13.75 0 -0.19 0.91c2.82,0.61 6.03,1.6 7.97,2.66 1.19,0.64 1.53,1.21 1.92,2.74l6.44 24.93 8.55 0 13.09 -31.24 -8.49 0z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisaBrand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visa-brand.svg";